// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import { Box, Typography } from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_admin/service-manager/$managedAccountId/basis',
)({
  component: RouteComponent,
  staticData: { crumb: 'service-manager:services.basis.title' },
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { managedAccountId } = useParams({
    from: '/$accountId/_admin/service-manager/$managedAccountId/basis',
  });

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={'space-between'}
        mb={2}
      >
        <Typography variant="h6" gutterBottom>
          {t('services.basis.title')}
        </Typography>
        <ServiceActivationSwitch
          managedAccountId={managedAccountId}
          servicePath="basis"
          ariaLabel={t('services.basis.title')}
        />
      </Box>

      <Typography variant="body1">{t('services.basis.description')}</Typography>
    </Box>
  );
}
